import { render, staticRenderFns } from "./BindCreative.vue?vue&type=template&id=5cb19f5e&scoped=true"
import script from "./BindCreative.vue?vue&type=script&lang=js"
export * from "./BindCreative.vue?vue&type=script&lang=js"
import style0 from "./BindCreative.vue?vue&type=style&index=0&id=5cb19f5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb19f5e",
  null
  
)

export default component.exports